import React, { useState, useEffect } from "react";
import { t } from "i18next";

import { getUserInfo } from "../../../api/usercall";
import Icon from "../../../common/components/Icon";

import individualTabs from "../tabs/individualTabs";
import businessTabs from "../tabs/businessTabs";
import dealerTabs from "../tabs/dealerTabs";

import PersonalInfo from "../tabs/PersonalInfo";
import AddressInfo from "../tabs/AddressInfo";
import GeneralInfo from "../tabs/GeneralInfo";
import AboutCompany from "../tabs/AboutCompany";
import ContactsInfo from "../tabs/ContactsInfo";
import DesignForm from "../tabs/DesignForm";

function Settings({ setActiveTab }) {
    const [activeTabV, setActiveTabV] = useState("personal");
    const [userInfo, setUserInfo] = useState(null);
    const [companyInfo, setCompanyInfo] = useState({});
    const [, setLocations] = useState([]);
    const [description, setDescription] = useState(companyInfo?.about?.text || "");
    const [isSubmitted, setIsSubmitted] = useState(false);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const data = await getUserInfo();
                setUserInfo(data.user);
                setLocations(data.locations);
                setCompanyInfo(data.company_info);
                if (data.user.user_type === "business" || data.user.user_type === "dealer") {
                    setActiveTabV("general");
                }
            } catch (error) {
                console.error("Error fetching user data:", error);
            }
        };
        fetchUserData();
    }, []);

    const handleDescriptionChange = (event) => {
        if (!event || !event.target) return;
        const value = event.target.value.trimStart();
        setDescription(value);
        localStorage.setItem("description", value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsSubmitted(true);
        if (!description.trim()) return;
    };

    const tabs = userInfo?.user_type === "individual"
        ? individualTabs(activeTabV, setActiveTabV)
        : userInfo?.user_type === "dealer"
            ? dealerTabs(activeTabV, setActiveTabV)
            : businessTabs(activeTabV, setActiveTabV);

    return (
        <div className="w-full">
            <div className="bg-white rounded-2xl overflow-hidden">
                {/* Mobile header */}
                <div className="flex items-center gap-3 px-4 pt-4 pb-2 md:hidden">
                    <Icon src="backicon" onClick={() => setActiveTab(null)} className="w-5 h-5 cursor-pointer flex-shrink-0" />
                    <span className="text-base font-semibold text-gray-800">{t('settings')}</span>
                </div>

                {/* Tab navigation */}
                <div className="border-b border-gray-100 px-4 overflow-x-auto">
                    <div className="flex gap-1 py-3 min-w-max">
                        {tabs}
                    </div>
                </div>

                {/* Tab content */}
                <div className="p-6">
                    {activeTabV === "personal" && userInfo && <PersonalInfo userInfo={userInfo} />}
                    {activeTabV === "address" && <AddressInfo />}
                    {activeTabV === "general" && <GeneralInfo companyInfo={companyInfo} userInfo={userInfo} />}
                    {activeTabV === "about" && (
                        <AboutCompany
                            handleSubmitProp={handleSubmit}
                            handleDescriptionChangeProp={handleDescriptionChange}
                            isSubmitted={isSubmitted}
                            description={description}
                        />
                    )}
                    {activeTabV === "contacts" && <ContactsInfo companyInfo={companyInfo} userInfo={userInfo} />}
                    {activeTabV === "design" && <DesignForm companyInfo={companyInfo} />}
                </div>
            </div>
        </div>
    );
}

export default Settings;
